var React = require('react');

function Spyglass (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M445.3,606.6l-139-139c26.9-33.2,43.1-75.5,43.1-121.5c0-106.6-86.8-193.4-193.4-193.4S-37.3,239.5-37.3,346.1\n\ts86.8,193.4,193.4,193.4c46,0,88.3-16.2,121.5-43.1l139,139c4,4,9.2,6,14.4,6s10.4-2,14.4-6C453.3,627.4,453.3,614.5,445.3,606.6z\n\t M156.1,498.8c-84.2,0-152.7-68.5-152.7-152.7s68.5-152.7,152.7-152.7s152.7,68.5,152.7,152.7S240.3,498.8,156.1,498.8z"}));
}

Spyglass.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"-49 141 512 512","style":{"enableBackground":"new -49 141 512 512"},"xmlSpace":"preserve"};

module.exports = Spyglass;

Spyglass.default = Spyglass;
